
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { useCustomRoutineName } from "@/hooks/useCustomNames";

interface RoutineNavigationProps {
  routines: any[];
  currentIndex: number;
  onTabChange: (value: string) => void;
}

interface RoutineTabTriggerProps {
  routine: any;
  index: number;
}

// Subcomponente: cada uno tiene sus propios hooks de forma estable.
// Esto evita el error #310 ("rendered more hooks than previous render")
// que ocurría al llamar useCustomRoutineName dentro de un .map().
const RoutineTabTrigger = ({ routine, index }: RoutineTabTriggerProps) => {
  const { customName } = useCustomRoutineName(routine?.id || "");

  return (
    <CarouselItem
      key={routine?.id || `routine-${index}`}
      className="pl-1 basis-auto"
    >
      <TabsTrigger
        value={index.toString()}
        className="dark:bg-black data-[state=active]:bg-primary data-[state=active]:text-primary-foreground dark:hover:bg-cyan-500 dark:data-[state=active]:bg-primary data-[state=active]:text-primary-foreground bg-primary/10 
        dark:text-white px-3 sm:px-4 text-sm whitespace-nowrap ocean:text-black ocean:data-[state=active]:bg-[#2196A3] ocean:data-[state=active]:text-white
        sunset:data-[state=active]:bg-[#ff5500] sunset:bg-[black] forest:data-[state=active]:bg-forest"
      >
        {customName || routine?.name || `Rutina ${index + 1}`}
      </TabsTrigger>
    </CarouselItem>
  );
};

export const RoutineNavigation = ({
  routines,
  currentIndex,
  onTabChange,
}: RoutineNavigationProps) => {
  return (
    <div className="relative">
      <Carousel>
        <CarouselContent className="-ml-1">
          <TabsList className="inline-flex h-10 items-center justify-start p-1 w-auto bg-transparent space-x-1">
            {routines.map((routine, index) => (
              <RoutineTabTrigger
                key={routine?.id || `routine-${index}`}
                routine={routine}
                index={index}
              />
            ))}
          </TabsList>
        </CarouselContent>
      </Carousel>
    </div>
  );
};
